import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';

// This component will redirect users from /jira/your-work to /jira/for-you.
// ScreenRedirect triggers a redirect ui event so we don't need to fire a manual operational event.
// We can remove this component once the frequency of the operational event is 0.
export const YourWorkRedirect = () => {
	return <ScreenRedirect to="/jira/for-you" />;
};
